import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootSaga from "../saga/rootSaga";
import authReducer from "./features/auth/authSlice";
import meReducer from "./features/me/userSlice";
import usersReducer from "./features/users/usersSlice";
import firstPasswordChangeReducer from "./features/firstPasswordChange/firstPasswordChangeSlice";
import userReducer from "./features/user/userSlice";
import fieldsTypeReducer from "./features/fieldsType/fieldsTypeSlice";
import fieldTypeReducer from "./features/fieldType/fieldTypeSlice";
import cropsReducer from "./features/crops/cropsSlice";
import cultureReducer from "./features/culture/cultureSlice";
import irrigationTypesReducer from "./features/irrigationTypes/irrigationTypesSlice";
import irrigationTypeReducer from "./features/irrigationType/irrigationTypeSlice";
import fieldsReducer from "./features/customer/fields/fieldsSlice";
import fieldReducer from "./features/customer/field/fieldSlice";
import fieldFormReducer from "./features/customer/fieldForm/fieldFormSlice";
import instrumentsReducer from "./features/customer/instruments/instrumentsSlice";
import sensorReducer from "./features/customer/sensor/sensorSlice";
import gatewayReducer from "./features/customer/gateway/gatewaySlice";
import gatewaysReducer from "./features/customer/instruments/gatewaysSlice";
import sensorTypesReducer from "./features/customer/sensorTypes/sensorTypesSlice";
import updateFrequenciesReducer from "./features/customer/updateFrequencies/updateFrequenciesSlice";
import sensorsReducer from "./features/customer/instruments/sensorsSlice";
import markerReducer from "./features/customer/marker/markerSlice";
import dragModeReducer from "./features/customer/marker/dragModeSlice";
import sensorHeatmapReducer from "./features/customer/sensorHeatmap/sensorHeatmapSlice";
import diseaseRiskReducer from "./features/customer/diseaseRisk/diseaseRiskSlice";
import weatherReducer from "./features/weather/weatherSlice";
import sensorDataReducer from "./features/customer/sensor/sensorDataSlice";
import sensorAverageDataReducer from "./features/customer/sensor/sensorAverageDataSlice";
import roverDataReducer from "./features/customer/roverData/roverDataSlice";
import resetPasswordReducer from "./features/resetPassword/resetPasswordSlice";
import resetPasswordRequestReducer from "./features/resetPassword/resetPasswordRequestSlice";
import changePasswordReducer from "./features/changePassword/changePasswordSlice";
import fieldNotesReducer from "./features/fieldNotes/fieldNotesSlice";
import fieldNoteReducer from "./features/fieldNote/fieldNoteSlice";
import diseaseReducer from "./features/diseases/diseasesSlice";
import diseaseStatusReducer from "./features/customer/diseaseStatus/diseaseStatusSlice";
import selectedFieldReducer from "./selectedFieldSlice";
import dtFieldsReducer from "./features/digitalTwin/dTFieldsSlice";
import plantsReducer from "./features/digitalTwin/plantsSlice";
import digitalTwinReducer from "./features/digitalTwin/digitalTwinSlice";
import selectedDigitalTwinReducer from "./features/digitalTwin/selectedDigitalTwinSlice";
import plantsMeasurementsReducer from "./features/digitalTwin/plantsMeasurementsSlice";
import rastersReducer from "./features/digitalTwin/rastersSlice";
import fieldImagesReducer from "./features/digitalTwin/fieldImagesSlice";
import plantDigitalTwinReducer from "./features/digitalTwin/plantDigitalTwinSlice";
import farmsReducer from "./features/digitalTwin/farms/farmsSlice";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    auth: authReducer,
    me: meReducer,
    users: usersReducer,
    firstPasswordChange: firstPasswordChangeReducer,
    user: userReducer,
    selectedField: selectedFieldReducer,
    fieldsType: fieldsTypeReducer,
    fieldType: fieldTypeReducer,
    crops: cropsReducer,
    culture: cultureReducer,
    irrigationTypes: irrigationTypesReducer,
    irrigationType: irrigationTypeReducer,
    fields: fieldsReducer,
    field: fieldReducer,
    fieldForm: fieldFormReducer,
    instruments: instrumentsReducer,
    sensor: sensorReducer,
    gateway: gatewayReducer,
    gateways: gatewaysReducer,
    sensorTypes: sensorTypesReducer,
    updateFrequencies: updateFrequenciesReducer,
    sensors: sensorsReducer,
    marker: markerReducer,
    dragMode: dragModeReducer,
    sensorHeatmap: sensorHeatmapReducer,
    diseaseRisk: diseaseRiskReducer,
    weather: weatherReducer,
    sensorData: sensorDataReducer,
    sensorAverageData: sensorAverageDataReducer,
    roverData: roverDataReducer,
    resetPassword: resetPasswordReducer,
    resetPasswordRequest: resetPasswordRequestReducer,
    changePassword: changePasswordReducer,
    fieldNotes: fieldNotesReducer,
    fieldNote: fieldNoteReducer,
    diseases: diseaseReducer,
    diseaseStatus: diseaseStatusReducer,
    /* digital twin data */
    dTFields: dtFieldsReducer,
    plants: plantsReducer,
    digitalTwin: digitalTwinReducer,
    selectedDigitalTwin: selectedDigitalTwinReducer,
    plantsMeasurements: plantsMeasurementsReducer,
    rasters: rastersReducer,
    fieldImages: fieldImagesReducer,
    plantDigitalTwin: plantDigitalTwinReducer,
    farms: farmsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
